var render = function render(){var _vm=this,_c=_vm._self._c;return _c('td',{staticClass:"orders-order"},[(_vm.text == 1)?_c('div',{staticClass:"badge badge-success"},[_vm._v("فعال")]):_vm._e(),(_vm.text == 0)?_c('div',{staticClass:"badge badge-danger"},[_vm._v("غير فعال")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }